// extracted by mini-css-extract-plugin
export default {"container":"Carousel_container__Jc3yN","carousel":"Carousel_carousel__iBwWE","fade":"Carousel_fade__2-mZm","item":"Carousel_item__qQbxL"};